export default __webpack_public_path__ + "static/media/infrastructure_and_virtualization_security.2342b3dd.png";